
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'SidebarCard',
})
export default class SidebarCard extends Vue {
    @Prop({ required: false }) private title!: string;
}
